import React from 'react';
import { Link } from 'react-router-dom';
import { projectsData } from '../data/projectsData';

const Projects = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Projects</h1>
          <p>Creative works, research initiatives, and safeguarding interventions</p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="projects-page">
        <div className="container">
          <div className="projects-grid full">
            {projectsData.map((project) => (
              <div key={project.id} className="project-card full">
                <div className={`project-image ${project.imageClass}`}>
                  {/* Image placeholder */}
                </div>
                <div className="project-content">
                  <h2 className='project-title-link'><Link to={`/project/${project.id}`}>{project.title}</Link></h2>
                  <p className="project-description">{project.shortDescription}</p>
                  
                  {project.tags && (
                    <div className="project-tags">
                      {project.tags.map((tag, index) => (
                        <span key={index} className="tag">{tag}</span>
                      ))}
                    </div>
                  )}
                  
                  <div className="project-links">
                    <Link to={`/project/${project.id}`} className="btn">View Details</Link>
                    {project.downloadable && (
                      <a href={project.downloadPath} className="btn btn-secondary" download>
                        Download {project.downloadLabel}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;